export default "__VITE_ASSET__ByrxHxy5__"